


















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { inputIsNumber, inputIsNumberWithSeparator, maximumAmountCurrency } from '@/utils/utils';

@Component
export default class PriceInput extends Vue {
  @Prop({ required: true, default: '' }) public readonly value: any;
  @Prop({ required: true, default: '' }) public initialAmount!: number|string|null;
  @Prop({ required: true }) public readonly currencyCode!: string;
  @Prop({ required: true, default: '' }) public readonly prevAmountNumber: any;
  @Prop() public blurHandler!: any;
  @Prop() public keyupEnterHandler!: any;
  @Prop() public keyupEscHandler!: any;
  @Prop({ default: true}) public inputShown!: boolean;
  @Prop({ default: false}) public disabled!: boolean;
  @Prop({ required: false, default: false}) public allowEmptyInput!: boolean;
  @Prop({ default: '' }) public className!: string;

  public freshInput: boolean = true;
  public maxLength = maximumAmountCurrency.hasOwnProperty(this.currencyCode) ?
      maximumAmountCurrency[this.currencyCode].toString().length + 1 : 8;
  public amountNumber: number = Number(this.initialAmount);
  public amount: string = this.displayPrice(this.initialAmount);

  public get classList() {
    return [{error: (!this.freshInput && this.errorInput)}, this.className.split(' ')];
  }

  get amountFromFormatted() {
    const amountArr = this.amount.split(this.separator);
    return Math.round(Number(amountArr.join('.')) * 100);
  }

  get errorInput(): boolean {
    if (!this.freshInput) {
      const hasError = isNaN(this.amountFromFormatted)
        || (this.amount !== ''
              && (this.amountFromFormatted < 0 || this.amountFromFormatted > maximumAmountCurrency[this.currencyCode]));
      this.$emit('inputError', hasError);
      return hasError;
    }
    this.$emit('inputError', false);
    return false;
  }

  /* istanbul ignore next */
  get separator() {
    return this.$store.getters.separator;
  }

  public verifyInput(event: KeyboardEvent) {
    if (this.freshInput) { this.freshInput = false; }
    const numberOfComma = (this.amount.toString().match(/,/g) || []).length;
    const numberOfPeriod = (this.amount.toString().match(/\./g) || []).length;
    const hasSeparator = numberOfComma > 0 || numberOfPeriod > 0;
    const processInput = hasSeparator ? inputIsNumber : inputIsNumberWithSeparator;
    if (!processInput(event, this.separator)) {
      event.preventDefault();
      const el = event.target as HTMLInputElement;
      const selectionStart = el.selectionStart || 1;
      const wrongSeparator = this.separator === '.' ? ',' : '.';
      if (event.key === wrongSeparator && !this.amount.includes(this.separator)) {
        this.amount = this.amount.substring(0, selectionStart) + this.separator + this.amount.substring(selectionStart);
        this.$nextTick(() => {
          el.setSelectionRange(selectionStart + 1, selectionStart + 1);
        });
      }
    }
  }

  public selectAll(event: MouseEvent) {
    setTimeout(() => (event.target as HTMLInputElement).select(), 100);
  }

  public displayPrice(price: any): string {
    if (price === null) { return ''; }
    return price % 100 === 0 ?
      String(price / 100).split('.').join(this.separator) :
      String((price / 100).toFixed(2)).split('.').join(this.separator);
  }

  public handleBlur(event: KeyboardEvent) {
    if (!this.blurHandler) {
      this.$emit('blur');
      return false;
    } else {
      this.blurHandler(event);
    }
  }

  public handleKeyUpEnter(event: KeyboardEvent) {
    if (!this.keyupEnterHandler) {
      return false;
    } else {
      this.keyupEnterHandler(event);
    }
  }

  public handleKeyUpEsc() {
    if (!this.keyupEscHandler) {
      return false;
    } else {
      this.keyupEscHandler();
    }
  }

  @Watch('amount', {immediate: true})
  private onAmountChange(value: number, oldVal: number) {
    if (value && value !== oldVal) {
      this.amountNumber = this.amountFromFormatted;
      this.$emit('input', this.amount);
    } else if (!value && this.allowEmptyInput) {
      this.amount = '';
      this.amountNumber = 0;
      this.$emit('input', this.amount);
      this.$nextTick(() => {
        this.$emit('inputError', true);
      });
    }
  }

  @Watch('initialAmount', {immediate: true})
  private onInitAmountChange(newValue: number, oldVal: number) {
    if (newValue && newValue !== oldVal) {
      this.amount = this.displayPrice(newValue);
      this.amountNumber = newValue;
    }
  }

  @Watch('inputShown', {immediate: true})
  private onInputShown(value: boolean) {
    if (value) {
      this.amount = this.displayPrice(this.initialAmount);
      this.amountNumber = Number(this.initialAmount);
      const hasError = isNaN(this.amountFromFormatted)
        || this.amount === ''
        || this.amountFromFormatted < 0;
      this.$emit('inputError', hasError);
    }
  }
}
